"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleItemToShow = void 0;
class ScheduleItemToShow {
    constructor() {
        this.id = 0;
        this.date = "";
        this.time = "";
        this.title = "string";
        this.subtitle = "";
    }
    static from(scheduleItem, title, date, timeStart, timeEnd) {
        const result = new ScheduleItemToShow();
        result.id = scheduleItem.id;
        result.date = date;
        if (scheduleItem.dateStartAndEndEquals()) {
            result.time = timeStart;
        }
        else {
            result.time = timeStart + " - " + timeEnd;
        }
        result.title = title;
        result.subtitle = scheduleItem.subtitle;
        return result;
    }
    static visibleFields() {
        return ["date", "time", "title", "subtitle"];
    }
}
exports.ScheduleItemToShow = ScheduleItemToShow;
